import { useState } from "react";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { todayIST } from "@/lib/format";

async function downloadXlsx(path, params, prefix) {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined && v !== false));
  const res = await api.get(path, { params: clean, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = /filename="?([^";]+)"?/.exec(cd)?.[1] || `${prefix}_${todayIST()}.xlsx`;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return name;
}

export const ExportButton = ({ path, params, prefix, testid }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const name = await downloadXlsx(path, params, prefix);
      toast.success(`Downloaded ${name}`);
    } catch {
      toast.error("Export failed, please try again");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" data-testid={testid} onClick={run} disabled={busy} className="btn-subtle h-10 shrink-0">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />}
      Export to Excel
    </button>
  );
};
